/**
 * VARIABLE_REGISTRY — keys disponíveis para mapear posições `{{N}}` de templates
 * HSM contra fields do contexto de runtime. Mantém paridade com
 * `apps/api/src/constants/variable-registry.ts` (defense in depth — backend
 * tem CHECK constraint + Drizzle + runtime validator).
 *
 * Mudanças aqui exigem mudança no backend correspondente para evitar 400
 * silenciosos via TypeBox.
 */
export const VARIABLE_REGISTRY = [
  'customer_name',
  'customer_first_name',
  'product_name',
  'order_value',
  'conversion_link',
  'phone_number',
  'customer_email',
  'product_id',
] as const;

export type VariableKey = (typeof VARIABLE_REGISTRY)[number];

/** Amostras pra preview dentro do editor (apenas UX, não vai pro Meta). */
export const VARIABLE_SAMPLES: Record<VariableKey, string> = {
  customer_name: 'João Silva',
  customer_first_name: 'João',
  product_name: 'Curso Reino Premium',
  order_value: 'R$ 497,00',
  conversion_link: 'https://reino.exemplo/checkout',
  phone_number: '+5511999998888',
  customer_email: 'cliente@exemplo.com',
  product_id: 'prod-7f2a3b...',
};
